import * as React from "react";
import styles from "./styles.scss";

export interface Props {
  children: React.ReactNode;
}

export default function FadeIn({ children }: Props) {
  return <div className={styles.container}>{children}</div>;
}
